/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION - COMMENT VOLUME: STYLES --------------- ++++++++++ */
export default theme => ({
  loginauthentication: {
    '& .explainer': {
      '& ul': {
        paddingLeft: pxToEm(20),
        marginBottom: pxToEm(20),
        '& li': {
          fontSize: pxToEm(14),
          marginBottom: pxToEm(10)
        }
      }
    },
    '& .previewconfig': {
      marginTop: pxToEm(-50) // move this up a bit to improve the visual awkwardness
    }
  }
});
